<template>
    <Breadcrumb :current="3" />

    <RicercaAuto v-if="mainStore?.type == 'auto'" />
    <RicercaCom v-else-if="mainStore?.type == 'vcom'" />
</template>

<script>
import Breadcrumb from './Breadcrumb.vue';
import RicercaAuto from './ricerca-modello/RicercaAuto.vue';
import RicercaCom from './ricerca-modello/RicercaCom.vue';
import { mainStore } from '../../../store/main';

export default {
    name: 'RicercaModello',
    components: { Breadcrumb, RicercaAuto, RicercaCom },

    data() {
        return {
            mainStore,
        }
    },

    created() {
        if (!this.mainStore?.type) {
            this.$notify({
                title: "Attenzione",
                text: "Selezionare tipo veicolo",
                type: "warn",
            });

            this.$router.push("/forecast/scelta-veicolo");
        }

        this.mainStore.forecast = {};
        this.mainStore.allestimentoVeicolo = {};
    }
}
</script>